import { put, takeLatest, call } from "redux-saga/effects";
import { drmFlipFlag } from "../../service/drmFlipFlag";
import { setFlipFlagSuccess, setFlipFlagFailure } from "../reducers/drmFlipFlagSlice";

export function* workerFlipFlag(action) {
  const { payload } = action;

  try {
    const response = yield call(drmFlipFlag, [
      payload.requestId,
      payload.processId,
      payload.sagaIds,
      payload.userName,
      payload.controller,
    ]);

    const successMessage = response?.data?.message || "Flag flipped successfully";
    yield put(setFlipFlagSuccess(successMessage));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.toString();
    yield put(setFlipFlagFailure(errorMessage));
  }
}

function* drmFlipFlagSaga() {
  yield takeLatest("drmFlipFlag/setFlipFlag", workerFlipFlag);
}

export default drmFlipFlagSaga;
